import React from 'react';

export default class VirtualTourModal extends React.Component {

    constructor(props) {
        super(props);

        this.events = {
            open: 'modal.virtualtour.open.'+props.id,
            //close: 'modal.virtualtour.close.'+props.id,
            //toggle: 'modal.virtualtour.toggle.'+props.id,
        }

        this.state = {
            open: false
        }

        this.EventManager = window.app.eventManager;
        this.EventManager.createEvent(this.events.open, 'Virtual tour open modal for '+props.id, 'This event is triggered when you want to open the relevant youtube modal', this);
        //this.EventManager.createEvent(this.events.close, 'Virtual tour close modal for '+props.id, 'This event is triggered when you want to close the relevant youtube modal', this);
        //this.EventManager.createEvent(this.events.toggle, 'Virtual tour toggle modal for '+props.id, 'This event is triggered when you want to close/open the relevant youtube modal', this);
    }

    componentDidMount() {
        this.EventManager.subscribe(this.events.open, (e) => {
            this.toggle(true);
        });
        /*this.EventManager.subscribe(this.events.close, (e) => {
            this.toggle(false);
        });
        this.EventManager.subscribe(this.events.toggle, (e) => {
            this.toggle();
        });*/
    }

    toggle = (open = null) => {
        open = (open !== null) ? open : !this.state.open;
        this.setState({open: open});
    }

    render() {
        let classname = 'modal-shroud' + (this.state.open ? '' : 'hidden');
        if(!this.state.open) return <></>;

        return (
            <div className={classname} onClick={ () => { this.toggle(false) }}>
                <div className="modal tour-modal">
                    <iframe src={`https://my.matterport.com/show/?m=${this.props.tourID}&log=0`} allowFullScreen allow="xr-spatial-tracking"></iframe>
                    <button className="modal-close" onClick={() => {this.toggle(false)}}>×</button>
                </div>
            </div>
        )
    }
};
